import { FormControlLabel, Checkbox as CheckboxUI } from '@mui/material'
import React from 'react'
import { FCWithChildren } from '@types'
import { CheckboxPropTypes } from './Checkbox.types'

export const Checkbox: FCWithChildren<CheckboxPropTypes> = ({
  formControlLabelProps,
  label,
  ...checkboxProps
}) => {
  const { sx: labelSx, ...formLabelProps } = formControlLabelProps || {}

  return (
    <FormControlLabel
      label={label}
      componentsProps={{ typography: { variant: 'body2' } }}
      color={checkboxProps.color}
      disabled={checkboxProps.disabled}
      control={<CheckboxUI {...checkboxProps} />}
      sx={{ marginLeft: 0, marginRight: 0, ...labelSx }}
      {...formLabelProps}
    />
  )
}

export * from './Checkbox.types'
export * from './components'
